import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/src/stylus/app.styl';
import en from 'vuetify/es5/locale/en';
import colors from 'vuetify/es5/util/colors';
import Resize from 'vuetify/lib/directives/resize';

Vue.use(Vuetify, {
  iconfont: 'md',
  lang: {
    locales: { en },
    current: 'en'
  },
  theme: {
    primary: '#0B3B5E', // colors.blue.darken1 #1E88E5 #2196F3
    secondary: '#FF2A52', //colors.red.base #F44336
    accent: colors.indigo.base // #3F51B5
  },
  directives: {
    Resize: Resize
  }
})
